import React, { Suspense, useState, useEffect } from "react";
import { useDispatch } from 'react-redux';
import { Outlet, useLocation } from "react-router-dom";

import Loader from './Loader';
import DashboardSidebar from "./DashboardSidebar";
import DashboardNavbar from "./DashboardNavbar";
import { StyledScrollContainer, StyledFixedElement } from './StyledScrollContainer';
import {
    profileRequest,
} from "../redux/auth/actions";


function getLoader() {
    return (
        <div className="flex items-center justify-center min-h-screen p-5 bg-gray-100 min-w-screen">
            <Loader />
        </div>
    )
}

const DashboadLayout = () => {
    const dispatch = useDispatch();
    const location = useLocation();

    const [locationKey, setLocationKey] = useState('');

    useEffect(() => {
        dispatch(profileRequest());
    }, [dispatch]);

    useEffect(() => {
        // hack to reinit scrollbars
        setTimeout(() => {
            setLocationKey(location + "_" + Math.random());
        });
    }, [location]);

    return (
        <div className="flex h-screen -overflow-hidden bg-[#F3F5F7]">
            <DashboardSidebar />

            {/* Main Content Area */}
            <StyledScrollContainer key={locationKey} className="flex flex-1 -overflow-y-auto flex-col w-full p-0 md:p-6 !pl-0 -max-w-[1400px] -mx-auto" hideFixedElementOnScroll={true}>
                <StyledFixedElement className="z-10 ns-fixed-element bg-[#F3F5F7EE] isolate w-full -md:w-[calc(100vw-300px-10rem)]" >
                    <DashboardNavbar />
                </StyledFixedElement>

                <div className="px-4 md:px-0 pt-[6rem] md:pt-[4.25rem]  w-full -md:w-[calc(100vw-300px-10rem)]">
                    <Suspense fallback={getLoader()}>
                        <Outlet />
                    </Suspense>
                </div>
            </StyledScrollContainer>
        </div>
    );
};

export default React.memo(DashboadLayout);
